import { useAuthorization } from "@/hooks/use-authorization";
import { Permissions } from "@/utils/permissions";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
} from "@elaniintc/goes-design-system";
import { NavLink } from "react-router";

interface TableDropdownProps {
  id: string;
  isInactive?: boolean;
  onEdit: (id: string) => void;
  onDuplicate: () => void;
  onDeactivate: (id: string) => void;
  onReactivate: (id: string) => void;
}

export default function TableDropdown({
  id,
  isInactive,
  onEdit,
  onDeactivate,
  onReactivate,
}: TableDropdownProps) {
  const { hasPermission } = useAuthorization();
  const canReadRegistry = hasPermission(
    Permissions["data-center"]["read-registry"],
  );
  const canEdit = hasPermission(Permissions["data-center"].update);
  const canDelete = hasPermission(Permissions["data-center"].delete);

  if (!canReadRegistry && !canEdit && !canDelete) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="xs"
          className="size-8 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering row click
          }}
        >
          <Icon type="far" name="ellipsis-vertical" className="text-current" />
          <span className="sr-only">Acciones para tabla {id}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[222px] min-w-56 rounded-lg border-neutral text-body font-normal p-2 font-geist"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        <DropdownMenuGroup>
          {!isInactive && (
            <>
              {canReadRegistry && (
                <DropdownMenuItem
                  className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                  asChild
                >
                  <NavLink
                    to={`/centro-de-datos/${id}`}
                    className="w-full"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering row click
                    }}
                  >
                    Ver tabla
                  </NavLink>
                </DropdownMenuItem>
              )}
              {canEdit && (
                <DropdownMenuItem
                  className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering row click
                    onEdit(id);
                  }}
                >
                  Editar detalles
                </DropdownMenuItem>
              )}
              {/* <DropdownMenuItem
                className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering row click
                  onDuplicate();
                }}
              >
                Duplicar tabla
              </DropdownMenuItem> */}
              {canDelete && (
                <DropdownMenuItem
                  className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer text-danger"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering row click
                    onDeactivate(id);
                  }}
                >
                  Desactivar tabla
                </DropdownMenuItem>
              )}
            </>
          )}
          {isInactive && canDelete && (
            <DropdownMenuItem
              className="hover:bg-neutral-object-accent-silent py-2 px-3 cursor-pointer text-danger"
              onClick={(e) => {
                e.stopPropagation(); // Prevent triggering row click
                onReactivate(id);
              }}
            >
              Reactivar tabla
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
